/* Base translations · Resample dialog — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): resample. */
export const I18N_BASE_RESAMPLE = {
  en: {
    resample: {
      title: "Re-sample",
      headerDesc: "The original sample is preserved. Every option creates a new child sample linked to this one so the audit trail is complete.",
      supplementLabel: "Supplement sample",
      supplementDesc: "Add more selections using the original methodology. Previously sampled items are excluded so nothing repeats. Use when the current sample turned up an unexpected exception rate and you need a bigger population coverage.",
      reviewLabel: "Review affected items",
      reviewDesc: "Only the items whose underlying GL record was modified or removed by a head-wise Replace upload. Matched by (voucher_no, account_code); rows with system-generated voucher placeholders are conservatively over-flagged.",
      newLabel: "Draw new sample",
      newDesc: "Redraws a fresh sample using the same method. The old sample is kept untouched and linked as the parent. A justification note is captured on the working-paper trail.",
      supplementOptions: "Supplement options",
      addlSize: "Additional sample size (optional)",
      defaultN: "Default: {n}",
      sheetName: "Sheet name (optional)",
      sheetSuffixSupplement: "{name} — Supplement",
      sheetSuffixNew: "{name} — New sample",
      scanning: "Scanning for affected items…",
      noReplaceYet: "No head-wise Replace upload has run on this engagement yet — nothing to compare against. Use {btn} below and pick Replace for the head(s) you want to re-verify.",
      uploadHeadwise: "Upload Head-wise GL",
      comparingAgainst: "Comparing against upload",
      fsHeadsLabel: " — FS heads ",
      affected: "affected",
      uidHdr: "UID",
      voucherHdr: "Voucher",
      accountHdr: "Account",
      reasonHdr: "Reason",
      andMore: "…and {n} more.",
      newDrawTitle: "Draw new sample — capture a justification",
      justification: "Justification note",
      justificationPh: "e.g. Original sample coverage insufficient after risk re-assessment.",
      sampleSize: "Sample size (optional)",
      running: "Running…",
      createLinked: "Create linked sample",
      previewFailed: "Failed to load preview",
      resampleFailed: "Re-sample failed",
      createdAffected: "Created {n} affected-items sheet",
      supplemented: "Supplemented — {n} new items drawn",
      newSampleDrawn: "New sample drawn — {n} items",
    },
  },
  ar: {
    resample: {
      title: "إعادة أخذ العينة",
      headerDesc: "العينة الأصلية محفوظة. كل خيار يُنشئ عينة فرعية جديدة مرتبطة بهذه العينة حتى يكتمل مسار التدقيق.",
      supplementLabel: "استكمال العينة",
      supplementDesc: "إضافة اختيارات باستخدام المنهجية الأصلية. البنود التي تم أخذها سابقاً مستبعدة حتى لا يتكرر شيء. استخدمها عندما تُظهر العينة الحالية نسبة استثناءات غير متوقعة وتحتاج إلى تغطية أوسع للمجتمع.",
      reviewLabel: "مراجعة البنود المتأثرة",
      reviewDesc: "فقط البنود التي تم تعديل أو إزالة سجلها في الأستاذ بواسطة عملية استبدال على مستوى البند. تتم المطابقة بواسطة (رقم السند، رمز الحساب)؛ الصفوف ذات أرقام السند المولّدة من النظام يتم الإفراط في تعليمها بشكل تحفظي.",
      newLabel: "سحب عينة جديدة",
      newDesc: "يعيد سحب عينة جديدة باستخدام نفس الطريقة. تُحفظ العينة القديمة دون تغيير وتُربط كأصل. يتم التقاط ملاحظة مبرّرة على مسار ورقة العمل.",
      supplementOptions: "خيارات الاستكمال",
      addlSize: "حجم العينة الإضافي (اختياري)",
      defaultN: "الافتراضي: {n}",
      sheetName: "اسم الورقة (اختياري)",
      sheetSuffixSupplement: "{name} — استكمال",
      sheetSuffixNew: "{name} — عينة جديدة",
      scanning: "جاري البحث عن البنود المتأثرة…",
      noReplaceYet: "لم يتم تشغيل أي عملية استبدال على مستوى البند على هذه المهمة بعد — لا يوجد ما يُقارن به. استخدم {btn} أدناه واختر استبدال للبند/البنود التي تريد إعادة التحقق منها.",
      uploadHeadwise: "رفع الأستاذ على مستوى البند",
      comparingAgainst: "المقارنة مع عملية الرفع",
      fsHeadsLabel: " — بنود القوائم ",
      affected: "متأثرة",
      uidHdr: "المعرّف",
      voucherHdr: "السند",
      accountHdr: "الحساب",
      reasonHdr: "السبب",
      andMore: "…و{n} أخرى.",
      newDrawTitle: "سحب عينة جديدة — التقاط مبرّر",
      justification: "ملاحظة المبرّر",
      justificationPh: "مثال: تغطية العينة الأصلية غير كافية بعد إعادة تقييم المخاطر.",
      sampleSize: "حجم العينة (اختياري)",
      running: "جاري التشغيل…",
      createLinked: "إنشاء عينة مرتبطة",
      previewFailed: "فشل تحميل المعاينة",
      resampleFailed: "فشل إعادة أخذ العينة",
      createdAffected: "تم إنشاء ورقة {n} من البنود المتأثرة",
      supplemented: "تم الاستكمال — تم سحب {n} من البنود الجديدة",
      newSampleDrawn: "تم سحب عينة جديدة — {n} بند",
    },
  },
};

export default I18N_BASE_RESAMPLE;
